// Dummy placeholder for CSS
export default class Tab {
}
//# sourceMappingURL=index.js.map